export const style = {
	container: {
		display: "flex",
		alignItems: "center",
		gap: "16px",
	},
};
